export * from "./pipes/shared-pipes.module";
export * from "./components";
export * from "./directives";
export * from "./modules";
export * from "./guard";
export * from "./pipes";
export * from "./services";
export * from "./reducers";
export * from "./actions";
export * from "./validators"



// WEBPACK FOOTER //
// ./src/app/shared/index.ts